export default "__VITE_ASSET__CNIzY1gO__"